<template>
    <Page class="relative" ref="pager" showSizer showElevator v-bind="$attrs" :page-size-opts="pagesizes"  @on-change='changePage' @on-page-size-change='changePageSize' show-total></Page>
</template>
<script>
export default {
	data(){
		return {
            pageRefresh: 1,
			pagesizes:[10,20,50,100,300,500]
		}
	},
    created () {
        this.$nextTick(() => {
            this.$refs.pager.$el.addEventListener('click', (e) => {
                if (this.pageRefresh === 1 && (e.target.className === 'ivu-page-item ivu-page-item-active' || e.target.parentElement.className === 'ivu-page-item ivu-page-item-active')) {
                    console.log(e.target.innerText);
                    this.$emit('on-update', { page: parseInt(e.target.innerText) });
                }
            });
        });
    },
	methods: {
		changePage(val) {
            this.pageRefresh = 0;
			this.$emit('on-update', { page: val });
            this.pageRefresh = 1;
		},
		changePageSize(val) {
			this.$emit('on-update', { rows: val, page: 1 });
		},
	},
};
</script>
